module.exports = __webpack_public_path__ + "static/media/foto_3.889a9420.png";